<ambita-cadastre-report-conveyance>
  <div class="ambita-cadastre-report__section" id="ambita-cadastre-report__conveyance" if="{ data.conveyance }">
    <h4 class="ambita-cadastre-report__section-title ambita-report-h4">
      { i18n.propertyLookup.titleConveyance }
    </h4>
    <table class="ambita-cadastre-report__list">
      <thead class="ambita-cadastre-report__header">
      <tr class="ambita-cadastre-report__row">
        <th>{ i18n.propertyLookup.conveyanceDate }</th>
        <th class="ambita-text-right">{ i18n.propertyLookup.conveyancePrice }</th>
        <th>{ i18n.propertyLookup.conveyanceType }</th>
        <th>{ i18n.propertyLookup.conveyanceDocumentCode }</th>
        <th>{ i18n.propertyLookup.conveyanceEntireProperty }</th>
        <th>{ i18n.propertyLookup.conveyanceMultipleCadastres }</th>
      </tr>
      </thead>
      <tbody>
      <tr class="ambita-cadastre-report__row">
        <td>{ data.conveyance.dateRegistered.ddmmyyyy }</td>
        <td class="ambita-text-right">{ formatCurrency(data.conveyance.purchasePrice) }</td>
        <td>{ data.conveyance.conveyanceType.text }</td>
        <td>{ data.conveyance.documentType.text || data.conveyance.documentCode.text }</td>
        <td>{ booleanWriter(data.conveyance.appliesToEntireCadastre) }</td>
        <td>{ booleanWriter(data.conveyance.multipleCadastres) }</td>
      </tr>
      </tbody>
    </table>
  </div>
  <script>
    import { init } from './sectionController';

    init(this);
  </script>
</ambita-cadastre-report-conveyance>
